"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const ListSeparator = ({ children }) => {
    return (React.createElement("div", { style: {
            minHeight: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            padding: '8px 0',
            boxSizing: 'border-box',
        } },
        React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: 24,
                height: '100%',
                width: 4,
                background: colors_1.quartz,
            } }),
        children));
};
const List = ({ separationElement, addElement, children, containerStyle }) => {
    const { Fragment } = React;
    return (React.createElement(Fragment, null,
        React.createElement(ListSeparator, null, separationElement),
        React.createElement("div", { style: Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16, background: colors_1.quartz, borderRadius: 4 }, containerStyle) }, children),
        addElement && (React.createElement(Fragment, null,
            React.createElement(ListSeparator, null),
            React.createElement("div", { style: {
                    marginLeft: 13,
                } }, addElement)))));
};
exports.default = List;
